import {
  IModel,
  Model,
  ModelRecord,
  IPhotoModel,
  PhotoModel,
  IStorageContentModel,
  StorageContentModel,
} from '@common/models';
import { DateTimeUtils } from '@common/utils';

import { DateTime } from 'luxon';

export interface IClientCommunicationListingModel extends IModel {
  communicationId: number;
  communicationMethodId: number;
  communicationDirectionId: number;
  content: string;
  storeId: number | undefined;
  storeName: string | undefined;
  dateCreated: string;
  readDate: string | undefined;
  readByName: string | undefined;
  sentByName: string | undefined;
  outboundSentByName: string | undefined;
  didSendMessage: boolean | undefined;
  photos: IPhotoModel[];
  subject: string;
  attachments: IStorageContentModel[];
}

export class ClientCommunicationListingModel
  extends Model
  implements ModelRecord<IClientCommunicationListingModel>
{
  communicationId: number;
  communicationMethodId: number;
  communicationDirectionId: number;
  content: string;
  storeId: number | undefined;
  storeName: string | undefined;
  subject: string | undefined;
  dateCreated: DateTime;
  readDate: DateTime | undefined;
  readByName: string | undefined;
  sentByName: string | undefined;
  outboundSentByName: string | undefined;
  didSendMessage: boolean | undefined;
  photos: IPhotoModel[];
  attachments: IStorageContentModel[];

  constructor(params?: Partial<IClientCommunicationListingModel>) {
    super(params);
    this.communicationId = _.defaultTo(params?.communicationId, 0);
    this.communicationMethodId = _.defaultTo(params?.communicationMethodId, 0);
    this.communicationDirectionId = _.defaultTo(
      params?.communicationDirectionId,
      0,
    );
    this.content = _.defaultTo(params?.content, '');
    this.storeId = _.defaultTo(params?.storeId, undefined);
    this.storeName = _.defaultTo(params?.storeName, undefined);
    this.dateCreated = DateTimeUtils.getAsDateTimeUTC(params?.dateCreated)!;
    this.readDate = DateTimeUtils.getAsDateTimeUTC(params?.readDate)!;
    this.sentByName = _.defaultTo(
      params?.sentByName ?? params?.outboundSentByName,
      '',
    );
    this.readByName = _.defaultTo(params?.readByName, '');
    this.didSendMessage =
      this.communicationDirectionId === 1
        ? true
        : _.defaultTo(params?.didSendMessage, false);
    this.photos = params?.photos
      ? params?.photos.map((p) => new PhotoModel(p))
      : ([] as PhotoModel[]);
    this.subject = _.defaultTo(params?.subject, '');
    this.attachments = params?.attachments
      ? params?.attachments.map((p) => new StorageContentModel(p))
      : ([] as StorageContentModel[]);
  }
}
